<script setup lang="ts">
import type { SelectLabelProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { SelectLabel } from 'reka-ui'

const props = defineProps<SelectLabelProps & { class?: HTMLAttributes['class'] }>()
const appConfig = useAppConfig()
</script>

<template>
  <SelectLabel :class="cn(appConfig.ui.select.slots.label, props.class)">
    <slot />
  </SelectLabel>
</template>
